import AccountCircle from "@mui/icons-material/AccountCircle";
import FlagIcon from "@mui/icons-material/Flag";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import VpnKey from "@mui/icons-material/VpnKey";
import {
  AppBar,
  Button,
  ClickAwayListener,
  FormControl,
  Grow,
  ListItemIcon,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Select,
  Toolbar,
} from "@mui/material";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logOut } from "../../actions/auth";
import {
  clearSavedCity,
  selectCity,
  selectCityFullInfo,
} from "../../actions/cities";
import {
  setMapBikeStateFilter,
  setMapStationStateFilter,
  setMapStationTypeFilter,
  setMapTypeFilter,
} from "../../actions/screen";
import {
  bikesStates,
  itemsTypes,
  stationStates,
  stationTypes,
} from "../../constants/const";
import { MFA_ROUTE } from "../../constants/routes";
import i18n, { localeLoad, strings } from "../../I18n";
import { logoutFromFirebase } from "../../utils/firebase";
import { getWhiteLabelLogo, getWhiteLabelTheme } from "../../utils/utils";
import "./styles.scss";
import InputBase from "@mui/material/InputBase/InputBase";

const Header = (props) => {
  const {
    adminDetails,
    logOut,
    setMapTypeFilter,
    setMapBikeStateFilter,
    setMapStationTypeFilter,
    setMapStationStateFilter,
    citiesList,
    savedCity,
    clearSavedCity,
  } = props;

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [item, setItem] = React.useState("");
  const [sortedCityList, setSortedCityList] = useState([]);
  const [city, setCity] = useState(null);
  const [logo, setLogo] = useState(null);

  const theme = useMemo(
    () => getWhiteLabelTheme(adminDetails?.whiteLabelCode),
    [adminDetails?.whiteLabelCode]
  );

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setLogo(getWhiteLabelLogo(adminDetails?.whiteLabelCode));
  }, [adminDetails]);

  useEffect(() => {
    if (savedCity && citiesList?.length > 0) {
      citiesList.forEach((city) => {
        if (city.id === parseInt(savedCity.split("cityId=")[1])) {
          setCity(city);
          setItem(city);
        }
      });
    }
  }, [savedCity, citiesList]);

  useEffect(() => {
    if (citiesList.length > 0) {
      const sortedCityList = [...citiesList];
      sortedCityList.sort((a, b) => a.name.localeCompare(b.name));
      setSortedCityList(sortedCityList);
    }
  }, [citiesList]);

  const onSelect = (event) => {
    if (event.target.value === "") {
      props.selectCityFullInfo("");
      props.selectCity("");
    } else {
      props.selectCityFullInfo(event.target.value);
      props.selectCity(`cityId=${event.target.value.id}`);
    }
    setItem(event.target.value);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  const logoutAction = useCallback(() => {
    setMapTypeFilter(itemsTypes);
    setMapBikeStateFilter(bikesStates);
    setMapStationTypeFilter(stationTypes);
    setMapStationStateFilter(stationStates);
    clearSavedCity();
    localStorage.removeItem("auth-store");
    sessionStorage.removeItem("preferV1UI");
    logOut();
    logoutFromFirebase();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLang = useCallback(async () => {
    if (i18n.defaultLocale === "nb") {
      await localeLoad("en");
    } else {
      await localeLoad("nb");
    }

    navigate(location.pathname, { replace: true });
  }, [navigate, location.pathname]);

  return (
    <div className="headerRoot">
      <AppBar
        position="static"
        style={{
          backgroundColor: theme.navBackground,
        }}
      >
        <Toolbar className="headerHeader">
          <img
            src={logo}
            alt="brand logo"
            className={`headerSiteLogo ${adminDetails?.whiteLabelCode === "sharebike" || !adminDetails?.whiteLabelCode ? "headerSiteLogo--shematic" : ""}`}
          />
          <Button
            onClick={() => {
              sessionStorage.removeItem("preferV1UI");
              navigate("/v2" + location.pathname + location.search);
            }}
            style={{
              color: theme.navText,
              marginRight: 16,
              marginLeft: 12,
              textTransform: "none",
              fontWeight: 600,
              backgroundColor: "rgba(255, 255, 255, 0.15)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              borderRadius: 20,
              paddingLeft: 16,
              paddingRight: 16,
              paddingTop: 6,
              paddingBottom: 6,
            }}
            startIcon={<SwapHorizIcon />}
            size="small"
          >
            Try New UI
          </Button>
          {adminDetails?.cityId === null ? (
            <FormControl variant="outlined" className="headerFormStyle">
              <Select
                displayEmpty={true}
                className="headerSelectStyle"
                style={{ color: theme.navText }}
                value={item}
                onChange={onSelect}
                input={<InputBase />}
                IconComponent={(props) => (
                  <KeyboardArrowDownIcon
                    {...props}
                    style={{ color: theme.navText }}
                  />
                )}
              >
                {savedCity && (
                  <MenuItem value={city}>
                    <span>{city?.name}</span>
                  </MenuItem>
                )}
                <MenuItem value="">
                  <span>{strings("descriptions.allCities")}</span>
                </MenuItem>
                {sortedCityList.map((eachCity) => {
                  return (
                    <MenuItem value={eachCity} key={eachCity.id}>
                      {eachCity.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          ) : (
            <div></div>
          )}
          <Button
            variant="h2"
            size="small"
            onClick={handleToggle}
            className="headerButton"
            style={{ color: theme.navText }}
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
          >
            {adminDetails?.email}
          </Button>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            transition={true}
            disablePortal={true}
            style={{ zIndex: 101 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem
                        className="headerMenuItem"
                        style={{ color: theme.navLogoutText }}
                        onClick={() => {
                          navigate(MFA_ROUTE);
                        }}
                      >
                        <ListItemIcon style={{ minWidth: "30px" }}>
                          <VpnKey fontSize="small" />
                        </ListItemIcon>
                        {strings("descriptions.enableMFA")}
                      </MenuItem>
                      <MenuItem
                        className="headerMenuItem"
                        style={{ color: theme.navLogoutText }}
                        onClick={logoutAction}
                      >
                        <ListItemIcon style={{ minWidth: "30px" }}>
                          <PowerSettingsNewIcon fontSize="small" />
                        </ListItemIcon>
                        {strings("descriptions.logOut")}
                      </MenuItem>

                      <MenuItem
                        className="headerMenuItem"
                        style={{ color: theme.navLogoutText }}
                        onClick={loadLang}
                      >
                        <ListItemIcon style={{ minWidth: "30px" }}>
                          <FlagIcon fontSize="small" />
                        </ListItemIcon>
                        {strings("descriptions.translate")}
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
          <AccountCircle style={{ color: theme.navText }} />
        </Toolbar>
      </AppBar>
    </div>
  );
};

const mapStateToProps = ({
  auth: { adminDetails },
  cities: { citiesList, savedCity },
}) => ({
  adminDetails,
  citiesList,
  savedCity,
});

const mapDispatchToProps = {
  logOut,
  setMapTypeFilter,
  setMapBikeStateFilter,
  setMapStationTypeFilter,
  setMapStationStateFilter,
  selectCity,
  clearSavedCity,
  selectCityFullInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
